export default __webpack_public_path__ + "static/media/excells-stamp.85e732ad.png";